import {
  PURCHASE_ORDER_PAYMENT_DATA_UPDATE,
  SELECT_PAYMENT_OPTION
} from '../../GlobalStateContainer'

export const PaymentOptions = function (state = [], action) {
  return state;
}

export const SelectedPaymentOptionId = function(state = '', action) {
  switch (action.type) {
    case SELECT_PAYMENT_OPTION:
      return action.paymentMethodId || '';
  }
  return state;
}

export const PaymentRecord = function (state = {}, action) {
  switch (action.type) {
    case PURCHASE_ORDER_PAYMENT_DATA_UPDATE:
      return Object.assign({}, state, { POValue: action.number });
  }
  return state;
}

export function selectedPaymentLabel(state = "None", action) {
  switch (action.type) {
    case SELECT_PAYMENT_OPTION:
      return action.displayName || '';
    case PURCHASE_ORDER_PAYMENT_DATA_UPDATE:
      return `Purchase Order ${((action.number.length > 0) ? " #: " : "")}${action.number}`;
  }
  return state;
}